import React, { createContext, useState } from "react";

export const UserContext = createContext();

// This context provider is passed to any component requiring the context
export const UserProvider = ({ children }) => {
  const [center, setCenter] = useState("Karr");

  return (
    <UserContext.Provider
      value={{
        center,
        setCenter
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
